module.exports = "<button class=\"goto\" data-goto=\"anchorID_1,anchorID_2,anchorID_3\">\n  Click me, I'll take you to a special place\n</button>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader?interpolate!./src/components/goto/sample.html
// module id = 48
// module chunks = 0